export default "__VITE_ASSET__CI9xFjaQ__"